import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {Result} from "@domain/common/http/result";
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import {SamlConfiguration} from "@domain/admin/parametre/authentification/saml-configuration";

/**
 * Service de gestion des appels pour authentification saml
 *
 * @author Lionel Gimenez
 * @date 25/07/2025
 */
@Injectable({
    providedIn: "root",
})
export class SamlHttpService {
    /**
     * Constructeur
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Charge la configuration SAML
     */
    load(): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/saml/loadConfig`,null);
    }

    /**
     * Sauvegarde la configuration SAML
     * @param samlConfig
     * @param idpFile
     */
    save(samlConfig: SamlConfiguration, idpFile?: File): Observable<Result> {
        const formData: FormData = new FormData();

        //Ajout de la configuration
        formData.append('config',new Blob([JSON.stringify(samlConfig)],{type: "application/json"}));
        
        //Ajout du fichier IDP si présent
        if (idpFile) {
            formData.append('idpFile', idpFile);
        }

        return this.http.post<Result>(`${environment.baseUrl}/controller/saml/saveConfig`,formData);
    }

    /**
     * Charge les métadonnées
     */
    metadonnees(): Observable<string> {
        return this.http.get(`${environment.baseUrl}/controller/saml/metadata`, { responseType: 'text' });
    }
}